// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZoNA","tabsBox":"styles_tabsBox__3tdWP","createButton":"styles_createButton__Oxr9u"};